import React from 'react';
import { FaPhone, FaEnvelope, FaHome, FaStar, FaHeart, FaShoppingCart, FaUser } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function Contact() {
  const [showPopup, setShowPopup] = React.useState(false);
  const [formData, setFormData] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 4000);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <>
      <Helmet>
        <title>Bromeli - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div className="container" style={{ padding: '40px 0' }}>
      <section className="contact-section">
        <div className="section-header">
          <h2>Lépjen kapcsolatba velünk</h2>
          <p>Kérdése van kertészeti témában? Keresse szakértői csapatunkat bizalommal.</p>
        </div>

        <div className="contact-info">
          <div className="contact-item">
            <h4><FaHome /> Címünk</h4>
            <p>0535 Budapest, Szilágyi udvar 9. 80. emelet, Magyarország</p>
          </div>
          <div className="contact-item">
            <h4><FaPhone /> Telefon</h4>
            <p>+36707470117<br />Hétköznap 8:00 - 17:00</p>
          </div>
          <div className="contact-item">
            <h4><FaEnvelope /> Email</h4>
            <p><a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a></p>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>Írjon nekünk üzenetet</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">Keresztnév*</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                placeholder="Írja be keresztnevét"
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Vezetéknév*</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                placeholder="Írja be vezetéknevét"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email cím*</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="bromeli@hotmail.com"
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Telefonszám</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                pattern="^\+?[0-9\s\-]{7,20}$"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+36 30 123 4567"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="message">Üzenet*</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Írja le kérdését vagy megjegyzését..."
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '15px', fontSize: '1.1rem' }}>
            Üzenet küldése
          </button>
        </form>
        <div style={{ marginTop: '30px', textAlign: 'center', color: '#6B6B6B', fontSize: '0.9rem' }}>
          <FaUser /> Regisztrációs szám: 40740896
        </div>
      </section>

      {showPopup && (
        <div className="notification" style={{ top: 'auto', bottom: '100px', right: '20px' }}>
          <FaStar style={{ marginRight: '8px' }} />
          Köszönjük szépen a megkeresését! Üzenetét megkaptuk, kollégánk hamarosan válaszol Önnek.
        </div>
      )}
    </div>
  
    </>);
}

export default Contact;